if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.navPrev = this.querySelector('.product-media-modal__nav--prev');
      this.navNext = this.querySelector('.product-media-modal__nav--next');
      this.counterCurrent = this.querySelector('.modal-counter--current');
      this.counterTotal = this.querySelector('.modal-counter--total');
      this.currentIndex = 0;

      if (this.navPrev) {
        this.navPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(-1);
        });
        // Stop pointerup from reaching the ModalDialog base class backdrop-close handler
        this.navPrev.addEventListener('pointerup', (e) => e.stopPropagation());
      }
      if (this.navNext) {
        this.navNext.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(1);
        });
        this.navNext.addEventListener('pointerup', (e) => e.stopPropagation());
      }

      // Stop pointerup on modal content from closing the modal
      const content = this.querySelector('.product-media-modal__content');
      if (content) {
        content.addEventListener('pointerup', (e) => e.stopPropagation());
      }

      // Stop pointerup on counter
      const counter = this.querySelector('.product-media-modal__counter');
      if (counter) {
        counter.addEventListener('pointerup', (e) => e.stopPropagation());
      }

      this.addEventListener('keyup', (e) => {
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    getVisibleSlides() {
      return Array.from(
        this.querySelectorAll('[data-modal-slide]')
      ).filter(el => !el.classList.contains('variant-media-hidden'));
    }

    showActiveMedia() {
      // The opener button has data-media-id with the raw media ID (no section prefix)
      const openedMediaId = this.openedBy.getAttribute("data-media-id");
      const slides = this.getVisibleSlides();

      slides.forEach((el) => el.classList.remove('active'));

      let activeIndex = 0;
      // Match raw media ID against data-modal-slide attribute
      const activeMedia = slides.find(el => el.dataset.modalSlide === openedMediaId);

      if (activeMedia) {
        activeMedia.classList.add('active');
        activeIndex = slides.indexOf(activeMedia);
      } else if (slides.length) {
        slides[0].classList.add('active');
      }

      this.currentIndex = activeIndex;
      this.updateCounter();
    }

    navigate(direction) {
      const slides = this.getVisibleSlides();
      if (!slides.length) return;

      if (slides[this.currentIndex]) {
        slides[this.currentIndex].classList.remove('active');
      }

      this.currentIndex += direction;
      if (this.currentIndex < 0) this.currentIndex = slides.length - 1;
      if (this.currentIndex >= slides.length) this.currentIndex = 0;

      slides[this.currentIndex].classList.add('active');
      this.updateCounter();
      this.loadActiveContent();
    }

    updateCounter() {
      const slides = this.getVisibleSlides();
      if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
      if (this.counterTotal) this.counterTotal.textContent = slides.length;
    }

    loadActiveContent() {
      const slides = this.getVisibleSlides();
      const activeSlide = slides[this.currentIndex];
      if (!activeSlide) return;

      window.pauseAllMedia();

      const deferred = activeSlide.querySelector('deferred-media');
      if (deferred) {
        const template = deferred.querySelector('template');
        const content = template ? template.content : null;
        if (content && content.querySelector('.js-youtube')) {
          deferred.loadContent();
        }
      }
    }
  });
}
